import React from "react";
import {
  CarouselActionType,
  NavigationTarget,
  type ICarouselItem,
} from "../types/models/carousel.models.types";
import { ExternalLink, Navigation } from "lucide-react";
import AddImageIcon from "../assets/svgs/common/add-image.svg";

interface Props {
  item: ICarouselItem;
  order?: number;
}

const CarouselListItemCard: React.FunctionComponent<Props> = ({
  item,
  order,
}) => {
  const actionLabel =
    item.action.type === CarouselActionType.LINK
      ? item.action.url ?? "—"
      : item.action.navigation?.target === NavigationTarget.CAMPAIGN_SCREEN
        ? `Campaign`
        : item.action.navigation?.target === NavigationTarget.PAYOUTS_SCREEN
          ? "Payouts Screen"
          : "—";

  return (
    <div className="flex items-center gap-4 w-full">
      <div className="flex-shrink-0 relative w-32 h-20 bg-sidemenu-bg rounded-lg overflow-hidden border border-border">
        {item.asset?.url ? (
          <img
            src={item.asset.url}
            className="w-full h-full object-cover"
            alt={item.asset.name}
          />
        ) : (
          <div className="flex justify-center items-center w-full h-full opacity-50">
            <AddImageIcon />
          </div>
        )}
      </div>

      <div className="flex flex-col flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          {order !== undefined && (
            <span className="text-primarytext text-lg font-bold px-2 py-0.5 rounded-full">
              # {order}
            </span>
          )}
          <div className="flex items-center gap-1 text-xs font-semibold text-secondary uppercase tracking-wider bg-badgebg px-2 py-1 rounded-md border border-border">
            {item.action.type === CarouselActionType.NAVIGATION ? (
              <><Navigation className="w-3 h-3" /> Navigation</>
            ) : (
              <><ExternalLink className="w-3 h-3" /> Link</>
            )}
          </div>
        </div>

        <p className="text-sm font-semibold truncate w-full" title={actionLabel}>
          Target: {actionLabel}
        </p>
        <p className="text-xs text-secondary truncate">
          By: {item.status.user.name || item.status.user.email || item.status.user.id}
        </p>
      </div>
    </div>
  );
};

export default CarouselListItemCard;
